module.exports = __webpack_public_path__ + "media/application/images/svgs/link-external-dark-8771c908e956d8d1fe45226e41103758.svg";